import { Components } from "appworks/components/components";
import { gameState } from "appworks/model/game-state";
import { Point } from "appworks/utils/geom/point";
import { Easing, Tween } from "appworks/utils/tween";
import { FowlSlingoReelHighlightComponent } from "components/fowl-slingo-reel-highlight-component";
import { FowlTicketMatrixComponent } from "components/fowl-ticket-matrix-component";
import { SlingoHighlightType, SlingoTicketMatrixComponent } from "slingo/components/slingo-ticket-matrix-component";
import { SlingoReelSpinResult } from "slingo/model/results/slingo-reel-spin-result";
import { SlingoPickJokerState } from "slingo/states/slingo-pick-joker-state";

export class FowlPickJokerState extends SlingoPickJokerState {
    protected highlightAlpha: number;
    protected highlightTween: Tween;

    public onEnter(): void {
        super.onEnter();

        const spinResult = gameState.getCurrentGame().getLatestResultOfType(SlingoReelSpinResult);
        spinResult.symbols.forEach((symbol: string, index: number) => {
            if (symbol === "J" && !this.isColumnFull(index)) {
                Components.get(FowlSlingoReelHighlightComponent)
                    .highlightSymbol(new Point(index, 0), SlingoHighlightType.JOKER)
                    .execute();
            } else if (symbol === "SJ") {
                Components.get(FowlSlingoReelHighlightComponent)
                    .highlightSymbol(new Point(index, 0), SlingoHighlightType.SUPER_JOKER)
                    .execute();
            }
        });

        this.highlightAlpha = 0.4;
        this.highlightTween = new Tween(this)
            .to({ highlightAlpha: 1 }, 400)
            .yoyo(true)
            .repeat(Infinity)
            .easing(Easing.Sinusoidal.InOut)
            .onUpdate(() => {
                Components.get(FowlSlingoReelHighlightComponent).setHighlightAlpha(this.highlightAlpha);
                Components.get(FowlTicketMatrixComponent).setHighlightAlpha(this.highlightAlpha);
            })
            .start();
    }

    protected onPick(value: number): void {
        super.onPick(value);

        this.highlightTween.stop();
        Components.get(FowlSlingoReelHighlightComponent).clearHighlights();
    }

    protected isColumnFull(colX: number): boolean {
        const ticketMatrix = Components.get(SlingoTicketMatrixComponent);

        for (let y = 0; y < 5; y++) {
            if (!ticketMatrix.isPositionDabbed(new Point(colX, y))) {
                return false;
            }
        }
        return true;
    }
}
